export default __webpack_public_path__ + "static/media/1.922304a1.jpg";